// extracted by mini-css-extract-plugin
export default {"tile1Card":"tiles_tile1Card__xyxsG","tile2Card":"tiles_tile2Card__hi6Ql","tile3Card":"tiles_tile3Card__ySQm2","tileIcons":"tiles_tileIcons__Vhsqp"};